import router from './index'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { Message } from '@element-plus/icons-vue'

const whiteList = ['/login', '/auth-redirect']

router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 确定用户是否已登录
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // 如果已登录，重定向到首页
      next({ path: '/' })
    } else {
      // 确定用户是否已通过getInfo获得其权限角色
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        try {
          // 获取用户信息
          const { roles } = await store.dispatch('user/getInfo')
          
          // 基于角色生成可访问的路由
          const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
          
          // 动态添加可访问路由
          router.addRoutes(accessRoutes)
          
          // 确保addRoutes完整的hack方法
          next({ ...to, replace: true })
        } catch (error) {
          // 移除token并重定向到登录页面
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
        }
      }
    }
  } else {
    /* 没有token */
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单中，直接进入
      next()
    } else {
      // 其他没有访问权限的页面被重定向到登录页面
      next(`/login?redirect=${to.path}`)
    }
  }
})

router.afterEach(() => {
  // 完成进度条等操作
})